/**
 * FilterChipButton
 * Shared filter chip trigger used across search, catalog, and connect pages.
 * Shows label + optional value + chevron icon. Always has border outline.
 */

import { ChevronsUpDown, ChevronUp } from "lucide-react"
import { forwardRef } from "react"

interface FilterChipButtonProps {
  label: string
  value?: string
  /** When true, shows upward chevron (popover is open) */
  isActive?: boolean
}

export const FilterChipButton = forwardRef<
  HTMLButtonElement,
  FilterChipButtonProps & React.ComponentPropsWithoutRef<"button">
>(({ label, value, isActive, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className="inline-flex items-center gap-[5px] rounded-[10px] p-[10px] border border-text-primary text-text-primary select-none transition-colors"
      {...props}
    >
      <span className="text-[14px] font-normal text-nowrap leading-[20px]">{label}</span>
      {value && (
        <span className="text-[14px] text-nowrap font-semibold leading-[20px]">{value}</span>
      )}
      {isActive ? (
        <ChevronUp className="size-[14px]" />
      ) : (
        <ChevronsUpDown className="size-[14px]" />
      )}
    </button>
  )
})
FilterChipButton.displayName = "FilterChipButton"
